import React from 'react';
import { CTA } from '../components/CTA';
import { Stethoscope, ShoppingBag, Brain, Microscope, Users, Activity, CheckCircle2 } from 'lucide-react';

export const Services: React.FC = () => {
  const allServices = [
    { 
        icon: Stethoscope, 
        title: "General Wellness", 
        desc: "Routine check-ups and preventative screenings tailored for men to catch issues before they become emergencies.",
        features: ["Preventive screenings", "Blood pressure monitoring", "Diabetes & cholesterol checks"]
    },
    { 
        icon: ShoppingBag, 
        title: "The Men’s Shop", 
        desc: "A curated selection of wellness essentials and lifestyle tools chosen with men’s real needs in mind.",
        features: ["Wellness essentials", "Lifestyle tools", "Clinician-recommended items"]
    },
    { 
        icon: Brain, 
        title: "Mental Health", 
        desc: "Confidential, judgment-free support to help men manage stress, anxiety, burnout, and life transitions.",
        features: ["Confidential counseling", "Stress management", "Burnout support"]
    },
    { 
        icon: Microscope, 
        title: "Sexual Health", 
        desc: "Discreet diagnostics and treatment for reproductive health in a safe space designed to protect your dignity.",
        features: ["ED/PE consultations", "STI testing & treatment", "Fertility support"]
    },
    { 
        icon: Users, 
        title: "Community", 
        desc: "Connect with daily health articles and local support groups to grow alongside other men on similar journeys.",
        features: ["Daily health articles", "Local support groups", "Peer-to-peer insights"]
    },
    { 
        icon: Activity, 
        title: "Lab Services", 
        desc: "Fast results and clear answers through quick turnaround diagnostic testing and easy-to-read digital reports.",
        features: ["Diagnostic blood tests", "Digital result access", "Clinician review"]
    }
  ];

  return (
    <div className="pt-20">
      {/* Header */}
      <div className="bg-white py-20 px-6">
        <div className="container mx-auto text-center">
             <span className="inline-block px-3 py-1 bg-blue-50 border border-blue-100 rounded-full text-xs font-bold text-primary uppercase tracking-wider mb-4">Our Expertise</span>
            <h1 className="text-4xl md:text-6xl font-bold text-secondary mb-6">Comprehensive Care <br/> For Every Stage of Life</h1>
            <p className="text-xl text-gray-500 max-w-2xl mx-auto">
              From preventative screenings to specialized lifestyle support, our digital clinic covers every aspect of modern men's health.
            </p>
        </div>
      </div>

      {/* Services Grid */}
      <div className="bg-gray-50 py-24">
         <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {allServices.map((service, i) => (
                    <div key={i} className="bg-white rounded-[2.5rem] p-8 shadow-sm hover:shadow-xl transition-all duration-300 group border border-gray-100 flex flex-col h-full">
                        <div className="w-14 h-14 bg-gray-50 rounded-2xl flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                            <service.icon size={28} />
                        </div>
                        <h3 className="text-2xl font-bold text-secondary mb-3">{service.title}</h3>
                        <p className="text-gray-500 mb-6 flex-1 text-sm leading-relaxed">{service.desc}</p>
                        
                        <div className="border-t border-gray-100 pt-6 mt-auto">
                            <h4 className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mb-4">What we offer</h4>
                            <ul className="space-y-3">
                                {service.features.map((feat, idx) => (
                                    <li key={idx} className="flex items-center gap-2.5 text-sm text-secondary font-semibold">
                                        <CheckCircle2 size={16} className="text-primary flex-shrink-0" />
                                        {feat}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
         </div>
      </div>

      <CTA />
    </div>
  )
}